module.exports = __webpack_public_path__ + "static/media/cancel.b9852b4d.svg";